import '../../../models/adyen/payment-type.js';
import { PaymentServiceProvider, PaymentMethod } from '../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../models/googlePay/types.js';
import '../../../models/payment/types.js';
import '../../../models/paypal/context.js';
import { Bancontact } from './Adyen/AdyenPaymentCard/Bancontact/Bancontact.js';
import BancontactSummary from './Adyen/AdyenPaymentCard/Bancontact/BancontactSummary.js';
import { Creditcard } from './Adyen/AdyenPaymentCard/Creditcard/Creditcard.js';
import CreditcardSummary from './Adyen/AdyenPaymentCard/Creditcard/CreditcardSummary.js';
import { ApplePay } from './Adyen/ApplePay/ApplePay.js';
import { BancontactMobile } from './Adyen/BancontactMobile/BancontactMobile.js';
import { Bizum } from './Adyen/Bizum/Bizum.js';
import { CashOnDelivery } from './Adyen/CashOnDelivery/CashOnDelivery.js';
import 'react';
import '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/utils';
import '../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import { GooglePayRegularContainer } from './Adyen/GooglePay/GooglePayRegularContainer.js';
import { Ideal } from './Adyen/Ideal/Ideal.js';
import { Klarna } from './Adyen/Klarna/Klarna.js';
import { KlarnaAccount } from './Adyen/KlarnaAccount/KlarnaAccount.js';
import { KlarnaPayNow } from './Adyen/KlarnaPayNow/KlarnaPayNow.js';
import { Mbway } from './Adyen/Mbway/Mbway.js';
import { MbwaySummary } from './Adyen/Mbway/MbwaySummary.js';
import { MobilePay } from './Adyen/MobilePay/MobilePay.js';
import { Multibanco as Multibanco$1 } from './Adyen/Multibanco/MultibancoContainer.js';
import { Multibanco } from './Adyen/Multibanco/component/Multibanco.js';
import { Oney } from './Adyen/Oney/Oney.js';
import { Paypal as Paypal$1 } from './Adyen/Paypal/Paypal.js';
import { Sepa } from './Adyen/Sepa/Sepa.js';
import { SepaSummary } from './Adyen/Sepa/SepaSummary.js';
import { Swish } from './Adyen/Swish/Swish.js';
import { Fake } from './Fake/Fake.js';
import { Paypal } from './Paypal/Paypal.js';

const P = PaymentServiceProvider;
const M = PaymentMethod;
const providers = {
    [P.FAKE]: {
        [M.FAKE]: {
            type: M.FAKE,
            provider: P.FAKE,
            form: Fake
        }
    },
    [P.PAYPAL]: {
        [M.PAYPAL]: {
            type: M.PAYPAL,
            provider: P.PAYPAL,
            form: Paypal
        }
    },
    [P.ADYEN]: {
        [M.IDEAL]: {
            type: M.IDEAL,
            provider: P.ADYEN,
            form: Ideal
        },
        [M.BANCONTACT_CARD]: {
            type: M.BANCONTACT_CARD,
            provider: P.ADYEN,
            form: Bancontact,
            summary: BancontactSummary
        },
        [M.CREDITCARD]: {
            type: M.CREDITCARD,
            provider: P.ADYEN,
            form: Creditcard,
            summary: CreditcardSummary
        },
        [M.PAYPAL]: {
            type: M.PAYPAL,
            provider: P.ADYEN,
            form: Paypal$1
        },
        [M.APPLE_PAY]: {
            type: M.APPLE_PAY,
            provider: P.ADYEN,
            form: ApplePay
        },
        [M.GOOGLE_PAY]: {
            type: M.GOOGLE_PAY,
            provider: P.ADYEN,
            form: GooglePayRegularContainer
        },
        [M.MOBILE_PAY]: {
            type: M.MOBILE_PAY,
            provider: P.ADYEN,
            form: MobilePay
        },
        [M.KLARNA]: {
            type: M.KLARNA,
            provider: P.ADYEN,
            form: Klarna,
            addCartToPayment: true
        },
        [M.KLARNA_PAY_NOW]: {
            type: M.KLARNA_PAY_NOW,
            provider: P.ADYEN,
            form: KlarnaPayNow,
            addCartToPayment: true
        },
        [M.BIZUM]: {
            type: M.BIZUM,
            provider: P.ADYEN,
            form: Bizum
        },
        [M.KLARNA_ACCOUNT]: {
            type: M.KLARNA_ACCOUNT,
            provider: P.ADYEN,
            form: KlarnaAccount,
            addCartToPayment: true
        },
        [M.MULTIBANCO]: {
            type: M.MULTIBANCO,
            provider: P.ADYEN,
            form: Multibanco,
            summary: Multibanco$1
        },
        [M.MBWAY]: {
            type: M.MBWAY,
            provider: P.ADYEN,
            form: Mbway,
            summary: MbwaySummary
        },
        [M.SEPA_DIRECT_DEBIT]: {
            type: M.SEPA_DIRECT_DEBIT,
            provider: P.ADYEN,
            form: Sepa,
            summary: SepaSummary
        },
        [M.ONEY]: {
            type: M.ONEY,
            provider: P.ADYEN,
            form: Oney
        },
        [M.SWISH]: {
            type: M.SWISH,
            provider: P.ADYEN,
            form: Swish
        },
        [M.BANCONTACT_MOBILE]: {
            type: M.BANCONTACT_MOBILE,
            provider: P.ADYEN,
            form: BancontactMobile
        }
    },
    [P.CASH_ON_DELIVERY]: {
        [M.CASH_ON_DELIVERY]: {
            type: M.CASH_ON_DELIVERY,
            provider: P.CASH_ON_DELIVERY,
            form: CashOnDelivery,
            addCartToPayment: true
        }
    }
};
const getPaymentImplementation = (provider, paymentMethod)=>{
    const providerMap = providers[provider];
    if (!providerMap) {
        return undefined;
    }
    return providerMap[paymentMethod];
};
const getPaymentMethodSettings = (provider, paymentMethod, paymentMethodsSettings)=>{
    if (!paymentMethodsSettings) {
        return undefined;
    }
    const paymentMethods = paymentMethodsSettings[provider];
    if (!paymentMethods) {
        return undefined;
    }
    return paymentMethods[paymentMethod];
};
const paymentMethodWithForm = (paymentMethod)=>{
    const paymentMethodsWithForm = [
        PaymentMethod.MBWAY,
        PaymentMethod.CREDITCARD,
        PaymentMethod.BANCONTACT_CARD,
        PaymentMethod.FAKE,
        PaymentMethod.ONEY,
        PaymentMethod.SEPA_DIRECT_DEBIT, 
    ];
    return paymentMethodsWithForm.includes(paymentMethod);
};

export { getPaymentImplementation, getPaymentMethodSettings, paymentMethodWithForm };
//# sourceMappingURL=providers.js.map
